import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ShortcutListVo} from '../../common/shared/api/gateway/shortcut/ShortcutListVo.interface';
import type {ApiResultVo} from '../../common/shared/api/karina/vo/ApiResultVo.interface';

/**
 * 바로가기 목록 조회
 *
 * Origin: pageKarinaApi.getShortcutList
 * API: GET /v1/shortcut/list
 */
export async function getShortcutList(
  options?: FetcherOptions
): Promise<ApiResultVo<ShortcutListVo>> {
  const response = await axiosBffFetch(
    '/api/gateway/view/v1/shortcut/list',
    {
      method: 'GET',
    },
    options
  );

  return response.data;
}
